import * as colors from "../../styles/colors";
import { node } from "prop-types";
import React from "react";
import { StyleSheet, css } from "aphrodite/no-important";

export const gradientStyleSheet = StyleSheet.create({
	gradient: {
		background: `linear-gradient(180deg, ${colors.docketDarkBlue}, ${colors.docketLightBlue})`,
		position: "absolute",
		top: "0",
		right: "0",
		bottom: "0",
		left: "0",
		display: "flex",
		flexDirection: "column",
		overflow: "auto",
	},
});

export const gradientProps = {
	children: node.isRequired,
};

export const Gradient = ({ children }) => (
	<div className={css(gradientStyleSheet.gradient)}>{children}</div>
);

Gradient.propTypes = gradientProps;
